<template>
  <div class="app flex-row align-items-center" id="form-reset-password">
    <div style="width: 100%;height: 100vh;">
      <CRow class="justify-content-center"
            style="height: 100%;margin: auto 0!important;background: url('../static/img/background-design.png');background-size: cover; background-repeat: no-repeat;">
<!--                <CCol id="content-left" col="0" md="8"-->
<!--                      style="background:url('../static/img/background-design.png'); background-size: cover; background-repeat: no-repeat;">-->
<!--                </CCol>-->
        <CCol id="content-right" md="12" xl="4" style="margin:auto;">
          <div class="container">
            <CCard no-body style="background: rgb(71 118 223 / 18%);border: none!important;">
              <CCardBody>
                <CForm id="form-login">
                  <h2 style="text-align:center;margin-bottom: 30px;font-weight: bold;">
                    Đổi mật khẩu
                  </h2>
                  <div class="mb-2" style="margin-top: 15px!important;">
                    <BaseInput
                      :options="oldPasswordInput.options"
                      :data="oldPasswordInput.data"
                    />
                  </div>
                  <div class="mb-2" style="margin-top: 20px!important;">
                    <BaseInput
                      :options="newPassWordInput.options"
                      :data="newPassWordInput.data"
                    />
                  </div>
                  <div class="mb-2" style="margin-top: 20px!important;">
                    <BaseInput
                      :options="confirmPassWordInput.options"
                      :data="confirmPassWordInput.data"
                    />
                  </div>
                  <CRow>
                    <CCol cols="12" style="margin-top: 15px!important;">
                      <button type="button" class="btn btn-primary btn-action-primary" @click="submit"><i
                        class="fa fa-check"></i> Xác nhận&nbsp;
                      </button>&nbsp;
                      <button type="button" class="btn btn-secondary btn-action-secondary" @click="cancel()">
                        <i class="fa fa-times"></i>&nbsp;Hủy bỏ&nbsp;
                      </button>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>

<script>
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";
import {authLogout} from "@/security/index"
import {ACCESS_TOKEN_EXPIRED} from "@/constant";

export default {
  name: 'ResetPassword',
  components: {BaseLoading, BaseInput},
  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted() {
    this.checkTimeExpToken();
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      oldPasswordInput: {
        options: {
          label: "Mật khẩu hiện tại <span class='required'>*</span>",
          placeholder: "Mật khẩu hiện tại",
          type: "password"
        },
        data: {
          name: "oldPassword",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.oldPasswordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu cũ không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu cũ sai định dạng";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      newPassWordInput: {
        options: {
          label: "Mật khẩu mới <span class='required'>*</span>",
          placeholder: "Mật khẩu mới",
          type: "password"
        },
        data: {
          name: "newPassword",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.newPassWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới sai định dạng";
              } else if (value.localeCompare(that.oldPasswordInput.data.model) == 0) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới không trùng mật khẩu hiện tại";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      confirmPassWordInput: {
        options: {
          label: "Xác nhận mật khẩu <span class='required'>*</span>",
          placeholder: "Xác nhận mật khẩu",
          type: "password"
        },
        data: {
          name: "newPasswordConfirm",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.confirmPassWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu sai định dạng";
              } else if (value.localeCompare(that.newPassWordInput.data.model) != 0) {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu không trùng mật khẩu mới";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
    }
  },
  computed: {},
  methods: {
    checkTimeExpToken() {
      let timeExpired = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (timeExpired) {
        let expiredTime = new Date(timeExpired * 1)
        let time = new Date();
        if (time >= expiredTime) {
          authLogout();
        }
      }
    },
    submit: function () {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/changePassword",
        isJsonContentType: false,
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          let dataResponse = response.data;
          if (dataResponse.returnCode !== 1) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data)
          } else {
            that.showSuccessMsg({message: 'Thay đổi mật khẩu thành công'})
            that.logout();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    logout: function () {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/logout",
        successCallback: function (response) {
          if (response.status === 200) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({message: that.$helper.getStringError(dataResponse.data)});
            } else {
              authLogout()
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    cancel: function () {
      this.$router.go(-1);
    }
  }
}
</script>
<style>

</style>
<style scoped>

</style>
